;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { AutomationStepRecord } from "@/lib/grpc/types";
import type { ProviderType } from "@/types/dataProvider";

export type Config = Record<string, unknown>;
export type Metadata = Record<string, unknown>;
export type { AutomationStepRecord } from "@/lib/grpc/types";

export enum AutomationTriggerType {
	MANUAL = "MANUAL",
	AUTOMATIC = "AUTOMATIC",
}

export enum AutomationStatus {
	DRAFT = "DRAFT",
	ACTIVE = "ACTIVE",
	PAUSED = "PAUSED",
	ARCHIVED = "ARCHIVED",
}

export interface CreateAutomationPayload {
	name: string;
	operationId: string;
	config?: Config;
	metadata?: Metadata;
	scheduleCron?: string;
	timezone?: string;
	status?: AutomationStatus;
	triggerType?: AutomationTriggerType;
	/** Skill Profile id — required when the operation declares profiles. */
	skillProfileId?: string;
}

export interface UpdateAutomationPayload {
	id: string;
	name?: string;
	config?: Config;
	metadata?: Metadata;
	scheduleCron?: string;
	timezone?: string;
	status?: AutomationStatus;
	triggerType?: AutomationTriggerType;
	isArchived?: boolean;
}

export interface GetAutomationsParams {
	search?: string;
	status?: AutomationStatus;
	isArchived?: boolean;
	operationId?: string;
	limit?: number;
	offset?: number;
}

export interface AutomationResult {
	id: string;
	organizationId: string;
	workspaceId: string;
	name: string;
	operationId: string;
	status: string;
	isArchived: boolean;
	triggerType: string;
	scheduleCron?: string;
	timezone: string;
	config: Config;
	metadata: {
		sourceProviders: ProviderType[];
		destinationProviders: ProviderType[];
		orchestratorId?: string;
		schedulerJobCreated?: boolean;
		schedulerJobCreatedAt?: Date;
		schedulerJobError?: string;
		skillDefinitionId?: string;
		webhook?: {
			enabled: boolean;
			events?: string[];
			provider?: string;
		};
	};
	createdBy?: string;
	createdAt: string;
	updatedAt: string;
	steps?: AutomationStepRecord[];
}

export interface GetAutomationsResult {
	automations: AutomationResult[];
	total: number;
}

// ==================== EXECUTION TYPES ====================

export enum ExecutionStatus {
	PENDING = "PENDING",
	QUEUED = "QUEUED",
	RUNNING = "RUNNING",
	COMPLETED = "COMPLETED",
	/** Every step ran, but a step deliberately left work undone (e.g. APM subscription held back). */
	PARTIALLY_COMPLETED = "PARTIALLY_COMPLETED",
	FAILED = "FAILED",
	CANCELLED = "CANCELLED",
	PAUSED = "PAUSED",
	SKIPPED = "SKIPPED",
}

export enum TriggerType {
	MANUAL = "MANUAL",
	API = "API",
	SCHEDULER = "SCHEDULER",
}

export interface StepExecutionResult {
	id: string;
	automationExecutionId: string;
	automationId: string;
	stepId: string;
	stepOrder: number;
	status: string;
	startedAt?: string;
	finishedAt?: string;
	recordsConsidered: number;
	recordsSkipped: number;
	recordsSucceeded: number;
	recordsFailed: number;
	errorCode?: string;
	errorSummary?: string;
	metadata: Metadata;
	createdAt: string;
	updatedAt: string;
}

export interface ExecutionResult {
	id: string;
	automationId: string;
	status: string;
	triggeredBy: string;
	triggeredByUser?: string;
	startedAt?: string;
	finishedAt?: string;
	recordsConsidered: number;
	recordsSkipped: number;
	recordsSucceeded: number;
	recordsFailed: number;
	errorSummary?: string;
	metadata: Metadata;
	createdAt: string;
	updatedAt: string;
	stepExecutions: StepExecutionResult[];
}

export interface GetExecutionsResult {
	executions: ExecutionResult[];
	total: number;
}

export interface TriggerAutomationResult {
	executionId: string;
	status: string;
	totalSteps: number;
	message: string;
}

export interface CancelExecutionResult {
	success: boolean;
	cancelledSteps: number;
	message: string;
}

export interface RetryExecutionResult {
	success: boolean;
	retriedFromStepId: string;
	stepOrder: number;
	message: string;
}

export interface GetExecutionsParams {
	limit?: number;
	offset?: number;
}

// ==================== QUICKBOOKS TRANS TYPE ====================

export interface ResolveTransTypeResult {
	customFieldDefinitionId?: string;
	message?: string;
}

// ==================== EXECUTION ARTIFACT ====================

export interface ExecutionArtifactResult {
	pull: Record<string, unknown>[];
	push: Record<string, unknown>[];
	/** Signed GCS URL — fetched server-side by the route handler, never sent to the browser */
	alternateArtifactFile?: string;
}

// ==================== QUICKBOOKS PROXY ====================

export type QuickBooksHttpMethod = "GET" | "POST" | "PUT" | "DELETE";

export interface QuickBooksProxyPayload {
	method: QuickBooksHttpMethod;
	path: string;
	queryParams?: Record<string, string>;
	body?: Record<string, unknown>;
	cacheTtlMs?: number;
}

export interface QuickBooksProxyResult {
	statusCode: number;
	data: unknown;
}
